import { render, staticRenderFns } from "./AppointmentSettings.vue?vue&type=template&id=4e7031e6&scoped=true"
import script from "./AppointmentSettings.vue?vue&type=script&lang=js"
export * from "./AppointmentSettings.vue?vue&type=script&lang=js"
import style0 from "./AppointmentSettings.vue?vue&type=style&index=0&id=4e7031e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7031e6",
  null
  
)

export default component.exports